import React from "react";
import "./App.css";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import CssBaseline from "@material-ui/core/CssBaseline";
import { Box, Tooltip } from "@material-ui/core";
import Question from "components/Screens/Question";
import EnhancedTable from "components/Tables/EnhancedTable";
import RegularTable from "components/Tables/RegularTable";
import useStyles from "./styles";
import { MAIL, OTC, POC } from "./constants";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import PersonIcon from "@mui/icons-material/Person";
import ApartmentIcon from "@mui/icons-material/Apartment";
import AirplaneTicketIcon from "@mui/icons-material/AirplaneTicket";

function App() {
  const [queryParams, setQueryParams] = React.useState({
    test_type: "FAMILY",
    frequency: "",
    conducted_by: "",
    time_to_result: "",
  });
  const customId = "custom-id-yes";
  const [data, setData] = React.useState([]);
  const [testConducted, setTestConducted] = React.useState(false);
  
  const [inpError, setInpError] = React.useState(false);
  const [family, setFamily] = React.useState(-1);
  const [expanded, setExpanded] = React.useState(-1);
  const handleAccordionChange = (panel) => (event, isExpanded) => {
    setData([]);
    setExpanded(isExpanded ? panel : false);
    setFamily(isExpanded ? panel : false);
    setUnder2Hours(false);
    setOver24Hours(false);
    setSingleEvent(false);
    setOngoingEvent(false);
    setSelfAdministered(false);
    setTrainedPersonel(false);
  };

  const [singleEvent, setSingleEvent] = React.useState(false);
  const [ongoingEvent, setOngoingEvent] = React.useState(false);
  const handleSingleEvent = () => {
    setData([]);
    setSingleEvent((prev) => !prev);
    setOngoingEvent(false);
    setTrainedPersonel(false);
    setSelfAdministered(false);
  };
  const handleOngoingEvent = () => {
    setData([]);
    setSingleEvent(false);
    setOngoingEvent((prev) => !prev);
  };

  const [under2Hours, setUnder2Hours] = React.useState(false);
  const [over24Hours, setOver24Hours] = React.useState(false);
  const handleUnder2Hours = () => {
    setData([]);
    setUnder2Hours((prev) => !prev);
    setOver24Hours(false);
  };
  const handleOver24Hours = () => {
    setData([]);
    setUnder2Hours(false);
    setOver24Hours((prev) => !prev);
  };

  const [selfAdministered, setSelfAdministered] = React.useState(false);
  const [trainedPersonel, setTrainedPersonel] = React.useState(false);
  const handleSelfAdministered = () => {
    setData([]);
    setSelfAdministered((prev) => !prev);
    setTrainedPersonel(false);
  };
  const handleTrainedPersonel = () => {
    setData([]);
    setSelfAdministered(false);
    setTrainedPersonel((prev) => !prev);
  };

  const handleResetClicked = () => {
    setUnder2Hours(false);
    setOver24Hours(false);
    setSingleEvent(false);
    setOngoingEvent(false);
    setSelfAdministered(false);
    setTrainedPersonel(false);
    setTestConducted(false);
    setQueryParams({
      test_type: "",
      frequency: "",
      conducted_by: "",
      time_to_result: "",
    });
    setData([]);
  };

  const assignPriority = (data, source) => {
    if (data && data.length) {
      data.forEach((d) => {
        const loc = source.findIndex((c) => {
          const reg = new RegExp("(?:^|\\W)" + c.toLowerCase() + "(?:$|\\W)");
          return reg.test(d.name.toLowerCase());
        });
        if (loc !== -1) {
          d.priority = "2";
        } else {
          d.priority = "1";
        }
      });
      data.sort((a, b) => b.priority.localeCompare(a.priority));
    }
  };

  const handleGetResults = () => {
    let test_type = "";
    if (family === 0) {
      test_type = "FAMILY";
    } else {
      test_type = "ORGANIZATION";
    }
    let time_to_result = "";
    if (under2Hours) {
      time_to_result = "LESS_THAN_2_HOURS";
    } else if (over24Hours) {
      time_to_result = "GREATER_THAN_24_HOURS";
    }
    let frequency = "";
    if (singleEvent) {
      frequency = "ONE_TIME";
    } else if (ongoingEvent) {
      frequency = "ONGOING";
    }
    let conducted_by = "";
    if (selfAdministered) {
      conducted_by = "SELF";
    } else if (trainedPersonel) {
      conducted_by = "HEALTHCARE_PROFESSIONAL";
    }
    setQueryParams({
      test_type: test_type,
      frequency: frequency,
      time_to_result: time_to_result,
      conducted_by: conducted_by,
    });
    family === 0 && (under2Hours || over24Hours)
      ? fetch(
          `${window.location.origin}/covid/tests/?test_type=${test_type}&time_to_result=${time_to_result}`
        )
          .then((response) => response.json())
          .then((data) => {
            time_to_result === "LESS_THAN_2_HOURS"
              ? assignPriority(data, [...OTC])
              : assignPriority(data, [...MAIL]);
            setData(cleansedData(data));
            if (data && data.length) {
              document.getElementById("optionResults").scrollIntoView();
            }
          })
      : family === 1 && frequency === "ONE_TIME" && (under2Hours || over24Hours)
      ? fetch(
          `${window.location.origin}/covid/tests/?test_type=${test_type}&time_to_result=${time_to_result}&frequency=${frequency}`
        )
          .then((response) => response.json())
          .then((data) => {
            time_to_result === "LESS_THAN_2_HOURS"
              ? assignPriority(data, [...POC, ...OTC])
              : assignPriority(data, [...MAIL]);
            setData(cleansedData(data));
            if (data && data.length) {
              document.getElementById("optionResults").scrollIntoView();
            }
          })
      : family === 1 &&
        frequency === "ONGOING" &&
        time_to_result !== "" &&
        conducted_by !== ""
      ? fetch(
          `${window.location.origin}/covid/tests/?test_type=${test_type}&time_to_result=${time_to_result}&frequency=${frequency}&conducted_by=${conducted_by}`
        )
          .then((response) => response.json())
          .then((data) => {
            conducted_by === "SELF"
              ? assignPriority(data, [...OTC])
              : assignPriority(data, [...POC, ...OTC]);
            setData(cleansedData(data));
            if (data && data.length) {
              document.getElementById("optionResults").scrollIntoView();
            }
          })
      : setInpError(true)
      const timer = setTimeout(() => {
        setInpError(false)
      }, 5000);
  };

  const BLANK_VALUE = "NA";

  const header = (text) => {
    return (
      <Box p={2}>
        <Grid container justify="flex-start" alignItems="center">
          <Grid item>
            <Box>
              <Typography
                variant="h4"
                style={{
                  font: "normal normal bold 40px/44px Arial",
                  letterSpacing: "-1.4px",
                  color: "#191919",
                }}
              >
                <b>{text}</b>
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </Box>
    );
  };
  const cleansedData = (data) => {
    // console.log(data);
    // data.forEach((p) => {
    //   if (p.products.length) {
    //     console.log(p.products)
    //   }
    // })
    if (trainedPersonel && family === 1 && over24Hours) {
      return data;
    } else if (Array.isArray(data)) {
      data.forEach((product) => {
        const statistics = product.stats;
        ["accuracy", "sensitivity", "time_to_result"].forEach((kpi) => {
          if (statistics[kpi] === -1) {
            product[kpi] = BLANK_VALUE;
          } else {
            product[kpi] = product.stats[kpi];
            if (kpi !== "time_to_result") {
              product[kpi] = (product.stats[kpi] * 100).toFixed();
            }
          }
        });
      });
      return data;
    }
  };
  const classes = useStyles();
  const num = [0, 1, 2];
  const FamilyTitle =
    "I am searching for a COVID-19 test for myself, my family or my friends";
  const OrgTitle = "I Need Tests for My Business / Organization";
  const InternationalTitle = "I am searching for a test for International Travel";

  return (
    <div
      style={{
        backgroundColor: "#fff",
        height: "100vh",
        overflow: "auto",
      }}
    >
      <CssBaseline />
      <Box p={2} className={classes.appBox} id="selectOptions">
        {header("Search for a Covid-19 test")}
        <Box p={2}>
          <Grid container direction="column">
            {num.map((i, _) => (
              <Grid item className={classes.appGrid} xs={12} key={i}>
                <Accordion
                  expanded={expanded === i}
                  onChange={handleAccordionChange(i)}
                  className={classes.accordion}
                >
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls={"panel" + i + "bh-content"}
                    id={"panel" + i + "bh-header"}
                    className={classes.accordionSummary}
                  >
                    <Typography className={classes.accordionTitle}>
                      {i === 0 ? (
                        <PersonIcon style={{ marginRight: "16px" }} />
                      ) : i === 1 ? (
                        <ApartmentIcon style={{ marginRight: "16px" }} />
                      ) : (
                        <AirplaneTicketIcon style={{ marginRight: "16px" }} />
                      )}
                      {i === 0
                      ? FamilyTitle
                      : i === 1
                        ? OrgTitle
                        : InternationalTitle
                      }
                    </Typography>
                  </AccordionSummary>
                  {
                    i === 2
                    ? (
                      <AccordionDetails className={classes.accordionDetails}>
                        <Typography
                          style={{ font: "normal normal bold 20px/26px Arial", marginBottom: "16px" }}
                        >
                          We recommend visiting:
                        </Typography>
                        <Button
                          variant="contained"
                          className={classes.resultsButton}
                          href="https://www.azova.com/traveltesting/index.html"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Visit Azova
                        </Button>
                      </AccordionDetails>
                    )
                    : (
                      <AccordionDetails className={classes.accordionDetails}>
                        {i ? (
                          <>
                            <Typography
                              style={{ font: "normal normal bold 20px/26px Arial" }}
                            >
                              I need to conduct a COVID-19 test:
                            </Typography>
                            <Button
                              variant="contained"
                              className={classes.optionsButton}
                              onClick={handleSingleEvent}
                              style={
                                singleEvent
                                  ? {
                                      background:
                                        "#FFC627 0% 0% no-repeat padding-box",
                                    }
                                  : null
                              }
                            >
                              Once or for a single event
                            </Button>
                            <Button
                              variant="contained"
                              className={classes.optionsButton}
                              onClick={handleOngoingEvent}
                              style={
                                ongoingEvent
                                  ? {
                                      background:
                                        "#FFC627 0% 0% no-repeat padding-box",
                                    }
                                  : null
                              }
                            >
                              <b>Multiple or for an ongoing event</b>
                            </Button>
                          </>
                        )
                        : null}
                        <Typography
                          style={{ font: "normal normal bold 20px/26px Arial" }}
                        >
                          I need the COVID-19 results in:
                        </Typography>
                        <Button
                          variant="contained"
                          className={classes.optionsButton}
                          onClick={handleUnder2Hours}
                          style={
                            under2Hours
                              ? {
                                  background: "#FFC627 0% 0% no-repeat padding-box",
                                }
                              : null
                          }
                        >
                          2 hours or less
                        </Button>
                        <Button
                          variant="contained"
                          className={classes.optionsButton}
                          onClick={handleOver24Hours}
                          style={
                            over24Hours
                              ? {
                                  background: "#FFC627 0% 0% no-repeat padding-box",
                                }
                              : null
                          }
                        >
                          24 hours or more
                        </Button>
                        {i ? (
                          <>
                            <Typography
                              style={{ font: "normal normal bold 20px/26px Arial" }}
                            >
                              I have need the COVID-19 tests administered by:
                            </Typography>
                            <Button
                              variant="contained"
                              className={classes.optionsButton}
                              onClick={handleTrainedPersonel}
                              disabled={singleEvent}
                              style={
                                trainedPersonel
                                  ? {
                                      background:
                                        "#FFC627 0% 0% no-repeat padding-box",
                                    }
                                  : null
                              }
                            >
                              Trained personnel
                            </Button>
                            <Button
                              variant="contained"
                              className={classes.optionsButton}
                              onClick={handleSelfAdministered}
                              disabled={singleEvent}
                              style={
                                selfAdministered
                                  ? {
                                      background:
                                        "#FFC627 0% 0% no-repeat padding-box",
                                    }
                                  : null
                              }
                            >
                              Self Administered
                            </Button>
                          </>
                        ) : null}
                        <div className={classes.resultsDiv}>
                          <p className={classes.inpErrorMsg}>
                            <small>
                            {inpError
                              ? "*Select from the options available to see the results."
                              : null}&nbsp;
                            </small>
                          </p>
                          <Button
                            variant="contained"
                            onClick={handleGetResults}
                            className={classes.resultsButton}
                          >
                            See my results
                          </Button>
                        </div>
                      </AccordionDetails>
                    )
                  }
                </Accordion>
              </Grid>
            ))}
          </Grid>
        </Box>
      </Box>
      {data && data.length ? (
        <Box p={2} className={classes.appBox} id="optionResults">
          {header("Available COVID-19 tests")}
          <div className={classes.appBoxText}>
            The results below are based on your criteria. You are able to sort
            by <b>Sensitivity</b> and <b>Specificity</b>. To sort tests, click
            the column header you need to sort by.
          </div>
          <div className={classes.appBoxText}>
            <b>Sensitivity</b> measures how often a test can provide a{" "}
            <b>correct positive test result</b> or how it often it correctly
            identifies the COVID-19 antibodies in a person. The lower the
            sensitivity can mean <b>false negative</b> results, the higher
            sensitivity means the higher chance to have a correct test result.
          </div>
          <div className={classes.appBoxText}>
            <b>Specificity</b> measures how often a test can provide a{" "}
            <b>correct negative test result</b> or how it often it correctly
            identifies that there are no COVID-19 antibodies in a person. The
            lower the specificity can mean <b>false positive</b> results, the
            higher specificity means the higher chance to have a correct test
            result.
          </div>
          {queryParams.test_type === "ORGANIZATION" &&
          queryParams.conducted_by === "HEALTHCARE_PROFESSIONAL" &&
          queryParams.time_to_result === "GREATER_THAN_24_HOURS" ? (
            <RegularTable data={data} />
          ) : (
            <EnhancedTable data={data} />
          )}
        </Box>
      ) : null}
    </div>
  );
}

export default App;
